import type { FC } from "react";
import React from "react";
import { Route, Routes } from "react-router-dom";

import { JobStatusListener } from "@react/domains/jobs";
import { AppHeader } from "@react/foundation/app";
import { NotFoundView } from "@react/foundation/placeholder";
import { AppContainer, PageContainer } from "@react/web/app";

import { AppMenu } from "./features/app-layout/index.ts";
import { AuthGuard, useLogout } from "./features/auth/index.ts";
import { GenerationStatusListener } from "./features/generation/index.ts";
import { NotificationProvider } from "./features/notification/index.ts";
import {
  authenticatedRoutes,
  navRoutes,
  unauthenticatedRoutes,
} from "./routes/routes.ts";

export const App: FC = () => {
  const { isSignedIn, logout } = useLogout();

  return (
    <AppContainer>
      <AppHeader
        items={navRoutes}
        rightContent={<AppMenu isSignedIn={isSignedIn} onLogout={logout} />}
        title="AptBlocks"
      />
      <Routes>
        {unauthenticatedRoutes.map(({ Component, path }) => (
          <Route element={<Component />} key={path} path={path} />
        ))}
        <Route
          element={
            <AuthGuard>
              <NotificationProvider>
                <JobStatusListener />
                <GenerationStatusListener />
                <Routes>
                  {authenticatedRoutes.map(({ Component, path }) => (
                    <Route element={<Component />} key={path} path={path} />
                  ))}
                  <Route
                    element={
                      <PageContainer>
                        <NotFoundView />
                      </PageContainer>
                    }
                    path="*"
                  />
                </Routes>
              </NotificationProvider>
            </AuthGuard>
          }
          path="*"
        />
      </Routes>
    </AppContainer>
  );
};
